import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DaysAgoPipe } from './days-ago/days-ago.pipe';
import { CommaSplitterPipe } from './comma-splitter/comma-splitter.pipe';
import { RemoveCharactersPipe } from './remove-characters/remove-characters.pipe';
import { CalendarTimePipe } from './calendar-time/calendar-time.pipe';
import { SanitizeHtmlPipe } from './sanitize-html/sanitize-html.pipe';
import { StripHtmlPipe } from './strip-html/strip-html.pipe';

@NgModule({
	declarations: [
		DaysAgoPipe,
		CommaSplitterPipe,
		RemoveCharactersPipe,
		CalendarTimePipe,
		SanitizeHtmlPipe,
		StripHtmlPipe
	],
	imports: [CommonModule],
	exports: [
		DaysAgoPipe,
		CommaSplitterPipe,
		RemoveCharactersPipe,
		CalendarTimePipe,
		SanitizeHtmlPipe,
		StripHtmlPipe
	],
})
export class PipesModule { }
